import { Divider, Grid, useMediaQuery } from "@mui/material";
import { apiClient } from "api/apiClient";
import Euler from "assets/euler.png";
import VideoThumnail from "assets/hiload-segment-tumbnail.webp";
import { useLanguage } from "LanguageContext";
import Features from "Pages/Landing/components/Fetures/Features";
import BottomContentLr from "Pages/StormEv-lr/components/BottomContent/bottom_content";
import ContactSection from "Pages/StormEv/components/ContactSection/ContactSection";
import { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { COLORS } from "theme";
import { sortData } from "utils";
import DesignContact from "./components/designContact";
import FaqComponent from "./components/Faq";
import FeatureSection from "./components/featureSection";
import Section from "./components/Sections/Sections";
import VideoSection from "./components/VideoSection/VideoSection";
import Hero from "./Hero/Hero";

const StormEv = () => {
  const small = useMediaQuery("(max-width: 768px)");
  const medium = useMediaQuery("(max-width: 1024px)");
  const { t } = useTranslation();
  const [refs, setRefs] = useState(null);

  const [testimonials, setTestimonials] = useState([]);
  const [testimonialsInfo, setTestimonialsInfo] = useState([]);
  const { selectedLanguage } = useLanguage();
  const [icons, setIcons] = useState([]);
  const [specifications, setSpecifications] = useState({});
  const [hiloadFeatures, setHiloadFeatures] = useState([]);

  const [hiloadSlider, setHiloadSlider] = useState([]);
  const [imageSliders, setImageSliders] = useState([]);
  const [currentFe, setCurrentFe] = useState(0);

  const [gallery, setGallery] = useState([]);

  const videoRef = useRef(null);
  const [videoUrl, setVideoUrl] = useState(null);
  const getRef = (ref) => {
    setRefs(ref);
  };
  useEffect(() => {
    // if (isInView) {
    // Simulate fetching video URL from API
    apiClient.getVideoById("storm_4w").then((res) => {
      setVideoUrl(`${res?.data[0]?.attributes?.url}`);
    });
  }, []);
  useEffect(() => {
    apiClient.getTestimonials(selectedLanguage).then((res) => {
      setTestimonials(res?.data);
    });
    apiClient.getTestimonialsInfo(selectedLanguage).then((res) => {
      setTestimonialsInfo(res?.data);
    });
    apiClient.getStormEvFeatures().then((res) => {
      setHiloadFeatures(sortData(res.data));
    });
    apiClient.getSpecifications().then((res) => {
      setSpecifications(res?.data);
    });
    apiClient.getIcons().then((res) => {
      setIcons(res?.data);
    });

    apiClient.getHiiloadSliders().then((res) => {
      setHiloadSlider(sortData(res.data));
    });
    apiClient.getImageSliderFourW().then((res) => {
      setImageSliders(sortData(res?.data));
      console.log(sortData(res?.data));
    });
    apiClient.getFourWGallery().then((res) => {
      setGallery(res?.data);
    });
  }, [selectedLanguage]);
  const sectionRef = useRef(null);
  const sectionRef2 = useRef(null);
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (sectionRef.current && sectionRef2.current) {
        const rect = sectionRef.current.getBoundingClientRect();
        const rect2 = sectionRef2.current.getBoundingClientRect();
        const scrollTop =
          window.pageYOffset || document.documentElement.scrollTop;

        // Make sticky only if the sectionRef is in view and before reaching sectionRef2
        if (
          rect.top <= 0 &&
          scrollTop <
            sectionRef.current.offsetTop + sectionRef.current.offsetHeight &&
          scrollTop < sectionRef2.current.offsetTop // Stop sticky when reaching sectionRef2
        ) {
          setIsSticky(true);
        } else {
          setIsSticky(false);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // State to track value updates
  const [updatedValueOfSection, setUpdatedValueOfSection] = useState("");

  // Callback function to update the value
  const handleSectionValueUpdate = (newValue) => {
    console.log("Updated Value:", newValue);
    setUpdatedValueOfSection(newValue);
  };
  const updateValueOfFe = (newValue) => {
    setCurrentFe(newValue - 1);
    console.log("Updated fer:", newValue);
  };

  return (
    <>
      <Grid item xs={12} style={{ padding: 0, marginTop: 71 }}>
        <Hero
          isHiload
          hiloadSlider={hiloadSlider}
          small={small}
          medium={medium}
          imageSliders={imageSliders}
        />
      </Grid>
      <Grid
        item
        xs={12}
        style={{
          paddingTop: !small && 0,
          paddingLeft: 0,
          background: COLORS.lightBlack,
        }}
      >
        <DesignContact small={small} medium={medium} />
      </Grid>
      <Grid item xs={12} style={{ padding: 0 }}>
        {videoUrl ? (
          <VideoSection
            videoUrl={videoUrl}
            small={small}
            fromHomePage
            isOverlay
            medium={medium}
          />
        ) : (
          <img src={VideoThumnail} alt="hiload segment video" ref={videoRef} />
        )}
      </Grid>
      {/* <Grid
        item
        xs={12}
        style={
          small
            ? {
                paddingLeft: "30px",
                paddingRight: "10px",
                paddingTop: "10%",
                // background: COLORS.black,
              }
            : { paddingBottom: "2%", paddingTop: "19%" }
        }
      >
        <GalleryImageView pics={gallery} small={small} />
      </Grid> */}
      <Grid
        item
        xs={12}
        ref={sectionRef}
        style={{
          background: "transparent",
          position: "static",
          top: "auto",
          zIndex: "auto",
        }}
      >
        <Grid
          item
          xs={12}
          style={{
            background: COLORS.lightBlack,
          }}
        >
          <FeatureSection
            small={small}
            setVal={updateValueOfFe}
            currentValue={updatedValueOfSection}
          />
        </Grid>
      </Grid>

      <Grid style={{ background: COLORS.lightBlack, width: "100%" }}>
        {hiloadFeatures.map((item, i) => (
          <Grid item xs={12} key={i}>
            <Section
              small={small}
              medium={medium}
              isStatic
              images={item?.attributes?.media}
              color={COLORS.white}
              id={item?.attributes?.sectionId}
              subtitle={item?.attributes?.subHeading}
              inverse={i % 2 === 0}
              onValueUpdate={handleSectionValueUpdate}
              img={
                !small
                  ? item?.attributes?.img?.data?.attributes?.url
                  : item?.attributes?.media_mobile?.data?.attributes?.url
              }
              alt={item?.attributes?.img?.data?.attributes?.alternativeText}
              getRef={getRef}
              name={item?.attributes?.heading}
              heading={item?.attributes?.subHeading}
              description={item?.attributes?.description}
              features={[
                {
                  id: 1,
                  title: item?.attributes?.featrure1,
                  img: item?.attributes?.feature1image?.data?.attributes?.url,
                  alt: item?.attributes?.feature1image?.data?.attributes
                    ?.alternativeText,
                },
                {
                  id: 2,
                  title: item?.attributes?.feature2,
                  img: item?.attributes?.feature2image?.data?.attributes?.url,
                  alt: item?.attributes?.feature2image?.data?.attributes
                    ?.alternativeText,
                },
                {
                  id: 3,
                  title: item?.attributes?.feature3,
                  img: item?.attributes?.feature3image?.data?.attributes?.url,
                  alt: item?.attributes?.feature3image?.data?.attributes
                    ?.alternativeText,
                },
                {
                  id: 4,
                  title: item?.attributes?.feature4,
                  img: item?.attributes?.feature4image?.data?.attributes?.url,
                  alt: item?.attributes?.feature4image?.data?.attributes
                    ?.alternativeText,
                },
              ]}
            />
          </Grid>
        ))}
      </Grid>

      <Grid
        item
        xs={12}
        ref={sectionRef2}
        style={{
          paddingTop: !small && 20,
          paddingLeft: 0,
          background: COLORS.lightBlack,
        }}
      >
        <Divider
          orientation="vertical"
          flexItem
          style={{
            backgroundColor: "#3C3C3C",
            height: "0.5px",
          }}
        />
        <ContactSection small={small} medium={medium} />
        <Divider
          orientation="vertical"
          flexItem
          style={{
            backgroundColor: "#3C3C3C",
            height: "0.5px", // Adjust height as needed
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <Features
          icons={icons}
          small={small}
          medium={medium}
          // OBJ={specifications}
        />
      </Grid>

      <Divider
        orientation="vertical"
        flexItem
        style={{
          backgroundColor: "#3C3C3C",
          height: "0.5px",
        }}
      />
      <Grid
        item
        xs={12}
        style={{
          backgroundColor: "#3C3C3C",
          height: "0.5px",
        }}
      />
      <Grid
        item
        xs={12}
        style={{
          background: COLORS.lightBlack,
        }}
      >
        <FaqComponent small={small} />
      </Grid>
      <Grid item xs={12}>
        <BottomContentLr small={small} medium={medium} />
      </Grid>
      <Helmet>
        <title>
          {t(
            "StormEV Electric Goods Carrier Vehicle | Pickup Trucks in India | Euler Motors"
          )}
        </title>
        <link rel="publisher" href="https://www.eulermotors.com/" />;
        <link rel="canonical" href="https://www.eulermotors.com/en/storm-ev" />
        <link rel="canonical" href="https://www.eulermotors.com/hi/storm-ev" />
        <link rel="canonical" href="https://www.eulermotors.com/ta/storm-ev" />
        <link rel="canonical" href="https://www.eulermotors.com/te/storm-ev" />
        <link rel="canonical" href="https://www.eulermotors.com/mr/storm-ev" />
        <link rel="canonical" href="https://www.eulermotors.com/gu/storm-ev" />
        <link rel="canonical" href="https://www.eulermotors.com/kn/storm-ev" />
        <link rel="canonical" href="https://www.eulermotors.com/bn/storm-ev" />
        {small ? (
          <link
            rel="preload"
            href="https://euler-assets.s3.ap-south-1.amazonaws.com/slider_intro_8bac516510.webp"
            as="image"
          />
        ) : (
          <link
            rel="preload"
            href="https://euler-assets.s3.ap-south-1.amazonaws.com/slider_intro_0788c3bc39.webp"
            as="image"
          />
        )}
        <meta
          name="title"
          content={t(
            "StormEV Electric Goods Carrier Vehicle | Pickup Trucks in India | Euler Motors"
          )}
        />
        <meta
          name="description"
          content={t(
            "Experience the power of StormEV T1250 by Euler Motors, India's best 4-wheeler electric commercial cargo vehicle for efficient loading and transportation. Book Now!"
          )}
        />
        ​
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.eulermotors.com/" />
        <meta
          property="og:title"
          content="Euler Motors | Electric Commercial Vehicle Manufacturers in India | EV Cargo Three Wheeler India"
        />
        <meta
          property="og:description"
          content="Experience the power of StormEV T1250 by Euler Motors, India's best 4-wheeler electric commercial cargo vehicle for efficient loading and transportation. Book Now!"
        />
        <meta property="og:image" content={Euler} />
        ​
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://www.eulermotors.com/" />
        <meta
          property="twitter:title"
          content="StormEV Electric Goods Carrier Vehicle | Pickup Trucks in India | Euler Motors"
        />
        <meta
          property="twitter:description"
          content="Experience the power of StormEV T1250 by Euler Motors, India's best 4-wheeler electric commercial cargo vehicle for efficient loading and transportation. Book Now!"
        />
        <meta property="twitter:image" content={Euler} />
      </Helmet>
    </>
  );
};

export default StormEv;
